/**
 * id {number, string} Column unique identificator
 * label {string} Column title
 * field_name {string} Column string identificator, used for slot reference
 * source_field {string}  Field name in the source data
 * showColumn {boolean} Enable the columns by default
 * alwaysVisible {boolean} Block making column visible / hidden
 * pinned {boolean} Pin the column
 * suppressSorting {boolead} Disable sorting
 */

export default [
  {
    id: 'learner_email',
    label: 'Email',
    field_name: 'learner_email',
    source_field: 'learner_email',
    customClass: 'email',
    showColumn: true,
    pinned: true,
  },
  {
    id: 'learner_first_name',
    label: 'First Name',
    field_name: 'learner_first_name',
    source_field: 'learner_first_name',
    showColumn: true,
  },
  {
    id: 'learner_last_name',
    label: 'Last Name',
    field_name: 'learner_last_name',
    source_field: 'learner_last_name',
    showColumn: true,
  },
  {
    id: 'learner_group_name',
    label: 'Group name',
    field_name: 'learner_group_name',
    source_field: 'learner_group_name',
    showColumn: true,
  },
  {
    id: 'class_start_time',
    label: 'Class start time',
    field_name: 'class_start_time',
    source_field: 'class_start_time',
    showColumn: true,
  },
  {
    id: 'scheduled_time',
    label: 'Scheduled timestamp',
    field_name: 'scheduled_time',
    source_field: 'scheduled_time',
    showColumn: false,
  },
  {
    id: 'status',
    label: 'Status',
    field_name: 'status',
    source_field: 'status',
    showColumn: true,
  },
  {
    id: 'length_of_class',
    label: 'Length of class',
    field_name: 'length_of_class',
    source_field: 'length_of_class',
    showColumn: true,
  },
  {
    id: 'credits_used_for_class',
    label: 'Credits Used for Class',
    field_name: 'credits_used_for_class',
    source_field: 'credits_used_for_class',
    showColumn: true,
  },
  {
    id: 'grammar',
    label: 'Grammar',
    field_name: 'grammar',
    source_field: 'grammar',
    showColumn: true,
  },
  {
    id: 'vocabulary',
    label: 'Vocabulary',
    field_name: 'vocabulary',
    source_field: 'vocabulary',
    showColumn: true,
  },
  {
    id: 'pronunciation',
    label: 'Pronunciation',
    field_name: 'pronunciation',
    source_field: 'pronunciation',
    showColumn: true,
  },
  {
    id: 'listening',
    label: 'Listening',
    field_name: 'listening',
    source_field: 'listening',
    showColumn: true,
  },
  {
    id: 'fluency',
    label: 'Fluency',
    field_name: 'fluency',
    source_field: 'fluency',
    showColumn: true,
  },
  {
    id: 'teacher_name',
    label: 'Teacher name',
    field_name: 'teacher_name',
    source_field: 'teacher_name',
    showColumn: true,
  },
  {
    id: 'cancellation_time',
    label: 'Cancellation Time',
    field_name: 'cancellation_time',
    source_field: 'cancellation_time',
    showColumn: false,
  },
];
